import { ReactElement, useMemo } from 'react';
import { Typography, Box } from '@mui/material';
import { Doughnut as DoughnutChart } from 'react-chartjs-2';

import LoadingFallback from '~components/LoadingFallback';
import { formatPercentage } from '~utils/formatter';

import { useReportsVisitsSectionContext } from '../../Context';

import { ReportsVisitsSectionChartsWrapperChart } from '../styles';

import { getFirstVisitDeliveriesChartProps } from './utils';

const ReportsVisitsSectionChartsFirstVisitDeliveries = (): ReactElement => {
  const {
    data: {
      summary: { data: summaryData, loading: loadingSummaryData },
    },
  } = useReportsVisitsSectionContext();

  const totalDeliveries = useMemo(
    () =>
      (summaryData?.firstVisitDeliveries ?? 0) +
      (summaryData?.multiVisitDeliveries ?? 0),
    [summaryData],
  );

  return (
    <ReportsVisitsSectionChartsWrapperChart>
      <Typography variant="body1" component="h4" fontWeight="bold">
        Entregas completas en primera visita
      </Typography>

      {loadingSummaryData && <LoadingFallback />}

      {!loadingSummaryData && summaryData && totalDeliveries === 0 && (
        <Box
          maxHeight={302}
          display="flex"
          alignItems="center"
          justifyContent="center"
          textAlign="center"
        >
          <Typography variant="body2" color="text.secondary">
            No hay entregas completadas en el período
          </Typography>
        </Box>
      )}

      {!loadingSummaryData && summaryData && totalDeliveries > 0 && (
        <Box maxHeight={302} sx={{ position: 'relative' }}>
          <DoughnutChart
            {...getFirstVisitDeliveriesChartProps(
              summaryData.firstVisitDeliveries,
              summaryData.multiVisitDeliveries,
            )}
          />

          <Box
            sx={{
              position: 'absolute',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              pointerEvents: 'none',
              maxWidth: 'max-content',
              height: 'max-content',
              top: 'calc(50% + 12px)',
              left: '50%',
              transform: 'translate(-50%, -50%)',
            }}
          >
            <Typography variant="h5" component="span" fontWeight="bold">
              {formatPercentage(summaryData.avgFirstVisitDelivery)}
            </Typography>

            <Typography variant="caption" color="text.secondary">
              de efectividad
            </Typography>
          </Box>
        </Box>
      )}
    </ReportsVisitsSectionChartsWrapperChart>
  );
};

export default ReportsVisitsSectionChartsFirstVisitDeliveries;
